import { useQuery } from '@tanstack/react-query';
import { PaymentAgreementService } from 'modules/conciliation/payment-agreement/services';
import { PAYMENT_AGREEMENTS_ONE_KEY } from 'modules/conciliation/payment-agreement/constants';
import { useCallback } from 'react';
import { IPaymentAgreement } from 'modules/conciliation/payment-agreement/interfaces';

export const useFindOnePaymentAgreement = (id: string | null) => {
  const fetch = useCallback(() => PaymentAgreementService.getOne(id as string), [id]);
  return useQuery<IPaymentAgreement>([id, PAYMENT_AGREEMENTS_ONE_KEY], fetch, { enabled: !!id });
};
